module.exports = __webpack_public_path__ + "static/media/flutter.bbba9449.webp";